export default __webpack_public_path__ + "static/media/bell-minus.0a64373e.svg";